<div class="flex justify-center items-center h-screen">
  <mat-card appearance="outlined" class="w-[90%] sm:w-3/5">
    <div class="flex flex-col md:justify-between md:flex-row">
      <div class="w-full">
        <mat-card-header>
          <mat-card-title> Forgot Your Password? </mat-card-title>
          <mat-card-subtitle>
            Enter the email address associated with your account.
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content class="w-full">
          <mat-progress-bar
            mode="indeterminate"
            *ngIf="loading"
            color="accent"
          ></mat-progress-bar>
          <form
            [formGroup]="forgotPasswordForm"
            (ngSubmit)="onSubmit()"
            class="flex flex-col mt-5"
          >
            <mat-form-field>
              <mat-label> Email Address</mat-label>
              <input
                type="email"
                matInput
                formControlName="emailFormControl"
                placeholder="Ex. pat@example.com"
              />
              <mat-icon matPrefix> mail_outline</mat-icon>

              @if
              (forgotPasswordForm.controls.emailFormControl.hasError('email') &&
              !forgotPasswordForm.controls.emailFormControl.hasError('required'))
              {
              <mat-error>Please enter a valid email address</mat-error>
              } @if
              (forgotPasswordForm.controls.emailFormControl.hasError('required'))
              {
              <mat-error>Email is <strong>required</strong></mat-error>
              }
            </mat-form-field>
            <button
              mat-raised-button
              type="submit"
              [disabled]="forgotPasswordForm.invalid"
              color="accent"
            >
              Submit
            </button>
            <button mat-button routerLink="/login">Back to Login</button>
          </form>
        </mat-card-content>
      </div>
      <div class="w-1/2 lg:w-1/3 flex self-center">
        <img
          src="assets\Circle Logo - White Background.png"
          class="self-center"
        />
      </div>
    </div>
  </mat-card>
</div>
